/**
 * PageViewTracker — fires a page_view to /api/analytics on every route change.
 * Powers the website-traffic side of the Growth Analytics module. Fail-soft.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/utils/analytics';

export default function PageViewTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Skip authenticated app + admin panels — we care about public/marketing reach.
    if (pathname.startsWith('/app') || pathname.startsWith('/tech-admin') || pathname.startsWith('/corvana-crm')) return;
    trackPageView(window.location.href);
  }, [pathname, search]);
  return null;
}
